import {
	Component,
	ViewEncapsulation,
	ViewChild,
	Input,
	ChangeDetectorRef
} from '@angular/core';

import { EventsService } from '@coreui//services/event.service'
import { UILayout } from '@coreui//services/ui.layout.service';


@Component({
	selector: 		'pm-appbar-routes',
	inputs: 			['route'],
	encapsulation: ViewEncapsulation.None,

	template:	`

			<div [ngSwitch]=this.uiLayout.windowClass 
				class="opacity-transition-350"
				[style.opacity]=_opacity>

				<div *ngSwitchCase="'compact'">
					<pm-appbar-compact></pm-appbar-compact>
				</div>

				<div *ngSwitchCase="'medium'">
					<pm-appbar-medium></pm-appbar-medium>
				</div>

				<div *ngSwitchCase="'expanded'">
					<pm-appbar-medium></pm-appbar-medium>
				</div>
				

			</div>

	`,

})


export class AppbarRoutes {

	uiLayout: UILayout
	private eventsService: EventsService
	_appbarRoutes: string = ""

	_opacity: number = 0

	private setRoute(route: string): void {
		setTimeout(() => {
			setTimeout(() => {
				this._appbarRoutes = route
			}, 150);
		}, 10);
	}

	constructor(private _eventsService: EventsService, private _uiLayout: UILayout) {
		this.eventsService = _eventsService
		this.uiLayout = _uiLayout
		this.uiLayout.windowClass

		let self = this;
		this.eventsService.on('onRefresh', function (args: any) {
		});
	}

	ngOnInit() {
		setTimeout(() => {
			this._opacity = 1
		}, 150);
	}

	ngOnDestroy() {
	}

	ngAfterViewInit() {

	}


}
